(() => {
  document.querySelectorAll("[data-snh-gallery]").forEach(gallery => {
    const image = gallery.querySelector(".snh-gallery-main img");
    if (!image) return;
    gallery.querySelectorAll("[data-snh-image]").forEach(button => {
      button.addEventListener("click", () => {
        const src = button.dataset.snhImage;
        if (!src) return;
        image.src = src;
        image.removeAttribute("srcset");
        image.alt = button.dataset.snhAlt || "";
        gallery.querySelectorAll("[data-snh-image]").forEach(item => item.setAttribute("aria-pressed", String(item === button)));
      });
    });
  });
  document.querySelectorAll("[data-snh-variant]").forEach(select => {
    select.addEventListener("change", () => {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", select.value);
      window.location.assign(url.toString());
    });
  });
  document.querySelectorAll(".snh-mobile-nav").forEach(menu => {
    menu.querySelectorAll("a").forEach(link => link.addEventListener("click", () => menu.removeAttribute("open")));
    document.addEventListener("click", event => {
      if (menu.open && !menu.contains(event.target)) menu.removeAttribute("open");
    });
    menu.addEventListener("keydown", event => {
      if (event.key === "Escape") {
        menu.removeAttribute("open");
        menu.querySelector("summary").focus();
      }
    });
  });
})();
